<template>
  <div
    class=""
    :class="className">
    <slot name="activator"/>
    <v-dialog
      v-model="model"
      :content-class="'dialog dialog-with-footer ' + dialog_class "
      persistent
      width="736">
      <div
        class="heaader"
        :class="{'no-title': !label}">
        <div
          v-if="label"
          v-dompurify-html="label"
          class="title"/>
        <div
          class="exit-btn">
          <sButton
            data-qa="btn-close-dialog"
            icon="cross"
            type="text"
            @click="$emit('close')"/>
        </div>
      </div>
      <div
        ref="wrapper"
        class="wrapper">
        <v-card
          class="card main__light_green py-0"
          :class="card_class"
          elevation="0">
          <v-card-actions
            class="pa-0"
            :class="actions_class">
            <slot name="actions"/>
          </v-card-actions>
          <slot name="after_actions"/>
          <v-card-text
            ref="card_text"
            class="pa-0"
            :class="card_text_class">
            <slot name="card_text"/>
          </v-card-text>
        </v-card>
      </div>
      <v-footer class="footer main__green">
        <v-row class="flex-nowrap">
          <v-col
            v-if="first_col_class"
            :class=" typeof first_col_class == 'string' ? first_col_class : 'col-6 py-0 d-flex align-center'"
            style="cursor: default">
            <slot name="first_col"/>
          </v-col>
          <div class="spacer"/>
          <v-col :class=" second_col_class || 'col-6 py-0 d-flex align-center'">
            <slot name="second_col"/>
          </v-col>
        </v-row>
      </v-footer>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'dialogTemplateWithFooter',
  props: {
    dialog: Boolean,
    className: String,
    dialog_class: String,
    label: String,
    first_col_class: [String, Boolean],
    second_col_class: [String, Boolean],
    actions_class: String,
    card_text_class: String,
    card_class: String,
    /**
     * Заголовок окна
     */
    title: {
      type: String,
    },
  },
  computed: {
    model: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog {
  .title {
    margin: auto 0;
    padding-left: 40px !important;
    text-align: left;
    font-weight: 600;
    font-size: 24px;
    max-width: calc(100% - 50px);
  }
}

.heaader {
  background: var(--v-secondary__green_chosen-base);
  text-align: right;
  padding: 5px 5px 0px 0px;
  min-height: 50px;
  display: flex;
  justify-content: space-between;
  &.no-title {
    justify-content: flex-end;
  }
}


.exit-btn {
  z-index: 210;
}
.wrapper{
  max-width: 100%;
  max-height: calc(70vh - 110px);
  height: calc(100% - 60px);
  overflow: auto;
  background: var(--v-main__light_green-base) ;
  background-color: var(--v-main__light_green-base) ;
  position: relative;

  .sticky {
    position: sticky;
    top: 0px;
    background: transparent !important ;
    background-color: transparent !important ;
    z-index: 30;
  }
}
.card {
  padding : 25px 25px 0;
  position: relative;
  border-radius: 0 !important ;
}
</style>
<style lang="scss">
.dialog-with-footer {

  .footer {
    position: sticky;
    top: calc(100% - 60px);
    z-index: 210;
    padding: 0 35px 0 25px;
    height: 60px;
  }

}
</style>
